export default __webpack_public_path__ + "static/media/13.8271b5fc.jpg";